import { render, staticRenderFns } from "./HomeAdministradorUnidade2.vue?vue&type=template&id=7015ac20&scoped=true"
import script from "./HomeAdministradorUnidade2.vue?vue&type=script&lang=js"
export * from "./HomeAdministradorUnidade2.vue?vue&type=script&lang=js"
import style0 from "./HomeAdministradorUnidade2.vue?vue&type=style&index=0&id=7015ac20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7015ac20",
  null
  
)

export default component.exports